/* unplugin-vue-components disabled */import { render } from "./link-saver.vue?vue&type=template&id=8308bf9c&scoped=true"
import script from "./link-saver.vue?vue&type=script&lang=js"
export * from "./link-saver.vue?vue&type=script&lang=js"

import "./link-saver.vue?vue&type=style&index=0&id=8308bf9c&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8308bf9c"],['__file',"src/controls/link-saver.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8308bf9c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8308bf9c', __exports__)) {
    api.reload('8308bf9c', __exports__)
  }
  
  module.hot.accept("./link-saver.vue?vue&type=template&id=8308bf9c&scoped=true", () => {
    api.rerender('8308bf9c', render)
  })

}


export default __exports__